export default __webpack_public_path__ + "static/media/library.0faac95b.webp";